import { Avatar } from '@infl-ts/ui-advocate-components';
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ProspectCard = function ProspectCard(_ref) {
  var sx = _ref.sx,
      _ref$prospect = _ref.prospect,
      name = _ref$prospect.name,
      title = _ref$prospect.title,
      company = _ref$prospect.company;
  return /*#__PURE__*/_jsx(Card, {
    elevation: 0,
    sx: mergeSxProps({
      maxWidth: 350,
      border: function border(t) {
        return "1px solid ".concat(t.palette.neutral.light);
      },
      mx: 'auto'
    }, sx),
    "data-element": "Card",
    "data-component": "ProspectCard",
    "data-source-file": "prospect-card.tsx",
    children: /*#__PURE__*/_jsxs(CardContent, {
      sx: {
        display: 'flex',
        gap: 3,
        alignItems: 'center',
        p: 2.25,
        '&:last-child': {
          pb: 2.25
        }
      },
      "data-element": "CardContent",
      "data-component": "ProspectCard",
      "data-source-file": "prospect-card.tsx",
      children: [/*#__PURE__*/_jsx(Avatar, {
        sx: {
          width: 40,
          height: 40
        },
        member: {
          id: name,
          name: name,
          avatarUrl: null
        },
        disabledPopover: true,
        "data-element": "Avatar",
        "data-component": "ProspectCard",
        "data-source-file": "prospect-card.tsx"
      }), /*#__PURE__*/_jsxs(Box, {
        "data-element": "Box",
        "data-source-file": "prospect-card.tsx",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h5",
          "data-element": "Typography",
          "data-source-file": "prospect-card.tsx",
          children: name
        }), /*#__PURE__*/_jsxs(Typography, {
          variant: "body2",
          "data-element": "Typography",
          "data-source-file": "prospect-card.tsx",
          children: [title, title && company && ' at ', company]
        })]
      })]
    })
  });
};

export default ProspectCard;